<div class="page-container">
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">calendar_month</mat-icon>
      <div>
        <div class="page-title">Return Frequencies</div>
        <div class="page-description">Configure the tax return filing frequencies available to registered accounts, such as Monthly and Quarterly.</div>
      </div>
    </div>
    <button mat-flat-button color="primary" class="add-button" (click)="addFrequency()">
      <mat-icon>add</mat-icon>
      ADD FREQUENCY
    </button>
  </div>

  <div class="mat-elevation-z2 table-card">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Return Frequencies">

      <ng-container matColumnDef="frequencyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Frequency Name</th>
        <td mat-cell *matCellDef="let row">{{ row.frequencyName }}</td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
        <td mat-cell *matCellDef="let row">
          <span class="code-badge">{{ row.code }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="filingPeriod">
        <th mat-header-cell *matHeaderCellDef>Filing Period</th>
        <td mat-cell *matCellDef="let row">{{ row.filingPeriod }}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="row.active ? 'status-active' : 'status-inactive'">
            {{ row.active ? 'Active' : 'Inactive' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="text-align: right; background-color: #E3E3E3;">Actions</th>
        <td mat-cell *matCellDef="let row" style="text-align: right;">
          <button mat-icon-button (click)="editFrequency(row); $event.stopPropagation()" aria-label="Edit frequency">
            <mat-icon class="action-icon edit-icon">edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteFrequency(row); $event.stopPropagation()" aria-label="Delete frequency">
            <mat-icon class="action-icon delete-icon">delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No return frequencies found.</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page"></mat-paginator>
  </div>
</div>
